import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.class.student.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_STUDENT_ASYNC: `${uid}.saveStudentAsync`,
    SAVE_STUDENT_SUCCESS: `${uid}.saveStudentSuccess`,
    SAVE_STUDENT_FAILURE: `${uid}.saveStudentFailure`,
    CREATE_STUDENT: `${uid}.createStudent`
};

export { ActionTypes };
